import { render } from "./k-btn-toggle.vue?vue&type=template&id=4e9bc048&scoped=true"
import script from "./k-btn-toggle.vue?vue&type=script&lang=js"
export * from "./k-btn-toggle.vue?vue&type=script&lang=js"

import "./k-btn-toggle.vue?vue&type=style&index=0&id=4e9bc048&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9bc048"]])

export default __exports__